import { routes } from '@/config/routes';

import { EmptyState } from './EmptyState';

export function ErrorState({
  title = 'Something went wrong',
  description = 'We could not load this content. Please try again in a moment.',
  onRetry,
}: {
  title?: string;
  description?: string;
  onRetry?: () => void;
}) {
  if (onRetry) {
    return (
      <div className="state-card" role="alert">
        <i className="pi pi-exclamation-circle" aria-hidden="true" />
        <h2>{title}</h2>
        <p>{description}</p>
        <button className="p-button p-component" type="button" onClick={onRetry}>
          Try again
        </button>
      </div>
    );
  }
  return (
    <EmptyState
      icon="pi pi-exclamation-circle"
      title={title}
      description={description}
      actionLabel="Return home"
      actionTo={routes.home}
    />
  );
}
